<template>
  <div class="addpaper">
    <el-form ref="form" :model="form" label-width="80px" label-position="top">
      <el-form-item label="试卷名称：">
        <el-input
          v-model="form.title"
          @keydown.enter.native="onSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item label="试卷说明：">
        <el-input type="textarea" v-model="form.brief"></el-input>
      </el-form-item>
      <el-form-item class="submint-btn">
        <el-button type="primary" @click="onSubmit">立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        title: "",
        brief: "",
      },
    };
  },
  methods: {
    onSubmit() {
      if (this.form.title == "") {
        this.$message("请输入试卷名称！");
      } else {
        this.$emit("addpaper", this.form);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.submint-btn {
  text-align: center;
}
</style>
